<template>
  <div v-if="value.length" class="recent-activity-widget__items">
    <component :is="item.typename" v-for="(item, index) in value" :key="index" :value="item" />
  </div>
  <EmptyState v-else :title="$t('noActivity')" :icon="['fal', 'bolt']" class="grow-1 mb-2" />
</template>

<script>
import EmptyState from '@/components/EmptyState'
import Types from './Types'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    EmptyState,
    ...Types,
  },
}
</script>

<style lang="scss">
.recent-activity-widget {
  overflow: hidden;

  .card__content {
    display: flex;
    flex-direction: column;
    padding: 0;
    flex-grow: 1;
    overflow-y: auto;

    @include scrollShadow();
  }

  .card__title {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: var(--card-spacing);
    background: linear-gradient(to bottom, white 55%, rgba(255, 255, 255, 0));
    margin-bottom: 0;
  }

  &__items {
    padding: 0 var(--card-spacing) var(--card-spacing) var(--card-spacing);
    margin-top: calc(var(--card-spacing) * -0.5);
  }
}
</style>
